import { Injectable } from '@angular/core'

import { environment } from '../../environments/environment'

@Injectable({
  providedIn: 'root'
})
export class PeopleAndOrgsService {

  public loadMissingPersonaInfo(): Promise<void> {
    return this.loadScripts('se-missing-persona-info')
  }

  private loadScripts(elementName: string): Promise<void> {
    return new Promise<void>((resolve) => {
      if (document.getElementById(elementName)) {
        resolve()
        return
      }

      ['runtime', 'polyfills', 'element'].forEach((name) => {
        const src = `${environment.peopleAndOrgsUrl}/${elementName}/${name}.js`
        const script = document.createElement('script')
        script.src = src
        script.type = 'module'
        script.async = false
        if (name === 'element') {
          script.id = elementName
          script.addEventListener('load', () => resolve())
        }
        document.body.append(script)
      })
    })
  }

}
